export const STEP_PAYMENT = 'payment';
export const STEP_OFFERS = 'offers';
export const STEP_SENDER = 'sender';
export const STEP_RECIPIENT = 'recipient';
export const STEP_CONFIRMATION = 'confirmation';
export const STEP_PAY = 'pay';
export const STEP_CC_PAYMENT = 'cc_payment';
export const STEP_SOURCE_OF_FUNDS = 'source_of_funds';
export const STEP_RECURRING_CARD_PAYMENT = 'pay_recurring';
export const STEP_RECURRING_DIRECT_DEBIT_PAYMENT = 'pay_recurring_direct_debit';
export const STEP_INDIA_OFFER_SELECTION = 'source_of_funds';
export const TRACK_PAYMENT = 'track';
export enum PaymentSteps {
  OFFERS = 'offers',
  SENDER = 'sender',
  RECIPIENT = 'recipient',
  CC_PAYMENT = 'cc_payment',
  CONFIRMATION = 'confirmation',
  RECURRING_CARD_PAYMENT = 'pay_recurring',
  RECURRING_DIRECT_DEBIT_PAYMENT = 'pay_recurring_direct_debit',
}

export enum PaymentStepsForIndia {
  SOURCE_OF_FUNDS = 'source_of_funds',
  OFFERS = 'offers',
  SENDER = 'sender',
  RECIPIENT = 'recipient',
  CC_PAYMENT = 'cc_payment',
  CONFIRMATION = 'confirmation',
  RECURRING_CARD_PAYMENT = 'pay_recurring',
  RECURRING_DIRECT_DEBIT_PAYMENT = 'pay_recurring_direct_debit',
}
